import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value"]

import { onMounted, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReadOnlyNote',
  props: {
  content: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const textarea = ref(null as HTMLElement | null);



onMounted(() => {
  textarea!.value!.style.height = "";
  textarea!.value!.style.height = textarea!.value!.scrollHeight + "px";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("textarea", {
    id: "note-id",
    name: "ReadOnlyNote",
    type: "text",
    height: "auto",
    disabled: "",
    ref_key: "textarea",
    ref: textarea,
    contenteditable: "false",
    draggable: "false",
    value: __props.content,
    class: "w-full overflow-auto border-none resize-none"
  }, null, 8, _hoisted_1))
}
}

})